export enum Aspect {
  Fit = "Fit", //letterboxes the image (if required) so that the entire image fits into the display area, with blank space added to the top/bottom or sides depending on whether the image is wide or tall.
  Fill = "Fill", //clips the image so that it fills the display area while preserving the aspect ratio.
}
